import React from 'react';
import { prettyAppointmentTime } from 'utils/timeUtils';

import './style.css';

const IssueAppointmentSummary = props => {
  return (
    <div className="AppointmentSummary mt-4">
      <div>
        {props.appointment.service.description} with {props.appointment.name}
      </div>
      <div>
        {prettyAppointmentTime(props.appointment.startTime)} for {props.appointment.duration} mins
      </div>
      <div>
        <i>{props.issue.issueType.description}</i>
      </div>
    </div>
  );
};

export default IssueAppointmentSummary;



// WEBPACK FOOTER //
// ./src/pages/student/ReportIssue/IssueAppointmentSummary/index.js